import { FacilitySortOption } from '@rematter/frontend-lib-api-client';

import { FacilityRecord, formatAddress } from '../types';

import { createQueryHook } from '~/shared/providers/api';

export interface FacilitiesQueryParams {
  searchTerm?: string;
  sorting?: FacilitySortOption[];
  limit?: number;
  offset?: number;
}

export interface FacilitiesQueryResult {
  facilities: FacilityRecord[];
  total: number;
}

export const useFacilitiesQuery = createQueryHook(
  'settings.teamPermissions.facilities',
  (params: FacilitiesQueryParams) => ({
    facilities: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 20,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        facilityName: true,
        address: {
          streetAddress: true,
          city: true,
          state: true,
          postalCode: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): FacilitiesQueryResult => ({
      facilities:
        data?.facilities.entries.map((facility) => ({
          id: facility.id,
          name: facility.facilityName,
          address: formatAddress(facility.address),
          userCount: 0,
          roleCount: 0,
        })) ?? [],
      total: data?.facilities.page.total ?? 0,
    }),
  },
);
